import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
})
export class AlertModalComponent implements OnInit {
  title: string;
  message: string;
  icon: string;
  cancelBtn: string;
  confirmBtn: string;
  status: string;
  disableClose: boolean;

  constructor(
    public dialogRef: MatDialogRef<AlertModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.message = this.data.message;
    this.icon = this.data.icon;
    this.cancelBtn = this.data.cancelBtn;
    this.confirmBtn = this.data.confirmBtn;
    this.status = this.data.status;
    this.disableClose = this.data.disableClose;
  }
  onDialogClose(): void {
    this.dialogRef.close(this.data);
  }
}